<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3071.52 345.67">
  <defs>

  </defs>
  <title>資產 13</title>
  <g id="headerpic" data-name="圖層 2">
    <g id="圖層_1-2" data-name="圖層 1">
      <path class="headcls-1" d="M1610,238.44.81,73.87,0,0H3070.2Z"/>
      <polygon class="headcls-2" points="1385.82 30.04 1447.81 0 0.08 0 0.08 57.23 679.43 99.87 851.92 53.66 1385.82 30.04"/>
      <polygon class="headcls-3" points="3071.52 335.53 3071.52 192.78 2892.3 136.76 2650.93 187.89 2429.08 73.87 1440.04 221.01 1378.49 296.7 3071.52 335.53"/>
      <polygon class="headcls-4" points="2650.93 187.89 2472.23 157.96 2429.08 73.87 2650.93 187.89"/>
      <g>
        <polygon class="headcls-5" points="1534.91 162.54 1578.36 130.82 1569.94 183.88 1534.91 162.54"/>
        <polygon class="headcls-5" points="1603.09 175.27 1569.94 183.88 1578.49 131.8 1603.09 175.27"/>
        <polygon class="headcls-5" points="1578.36 130.82 1623.96 95.91 1647.8 165.33 1603.09 175.27 1578.36 130.82"/>
        <polygon class="headcls-5" points="1623.96 95.91 1671.6 101.06 1675.98 125.73 1657.23 192.3 1623.96 95.91"/>
        <polygon class="headcls-5" points="1634.67 168.61 1637.24 187.98 1646.93 165.54 1634.67 168.61"/>
        <polygon class="headcls-5" points="1649.21 98.43 1635.29 40.45 1658.57 58.84 1671.6 101.06 1649.21 98.43"/>
        <polygon class="headcls-5" points="1546.84 169.91 1495.18 212.84 1569.94 183.88 1546.84 169.91"/>
        <line class="headcls-6" x1="1649.21" y1="98.43" x2="1658.57" y2="58.84"/>
        <polygon class="headcls-5" points="1597.19 32.49 1635.19 39.68 1641.49 66.28 1597.19 32.49"/>
        <polyline class="headcls-5" points="1578.91 181.55 1573.59 191.77 1495.18 212.84"/>
        <polyline class="headcls-5" points="1534.91 162.54 1477.38 206.09 1511.82 199.02"/>
        <polyline class="headcls-5" points="1535.07 122.96 1517.95 122.99 1505.06 150.76 1537.25 160.09 1535.07 122.96 1576.85 132.01"/>
        <polyline class="headcls-5" points="1505.06 150.76 1511.28 162.6 1537.25 160.09"/>
        <polyline class="headcls-5" points="1511.28 162.6 1511.11 168.39 1520.59 173.38"/>
        <path class="headcls-5" d="M1511.28,162.6c.25.52,3.14,7.53,3.14,7.53"/>
        <path class="headcls-5" d="M1517.63,123.69l-15.13.37s-7.88,3.58-8.19,4.08,5.68,5.46,5.68,5.46h0l10.13,6.25"/>
        <polyline class="headcls-5" points="1499.94 133.81 1495.29 135.67 1500.14 138.93 1507.32 145.88"/>
        <polyline class="headcls-5" points="1541.49 166.55 1573.81 160.33 1603.09 175.27 1640.97 145.44"/>
        <polyline class="headcls-5" points="1671.6 101.06 1640.97 145.44 1675.98 125.73"/>
        <line class="headcls-6" x1="1569.94" y1="183.88" x2="1573.59" y2="191.77"/>
        <polyline class="headcls-5" points="1578.49 131.8 1613.34 150.02 1640.97 145.44"/>
        <line class="headcls-6" x1="1613.34" y1="150.02" x2="1603.09" y2="175.27"/>
      </g>
      <polygon class="headcls-7" points="0.03 73.44 1440.03 221.44 1378.03 296.44 0.03 345.67 0.03 73.44"/>
    </g>
  </g>
</svg>

</template>

<script>
export default {

}
</script>

<style lang="sass">
#headerpic
  position: relative
  z-index: 80
.headcls-1 
  fill: #f7f7f7
      

.headcls-2 
  fill: #efefef


.headcls-3 
  fill: #ededee


.headcls-4 
  fill: #e4e4e4


.headcls-5, .headcls-6 
  fill: none
  stroke: #c7c8c9
  stroke-miterlimit: 10
  stroke-width: 1.5px


.headcls-5 
  fill-rule: evenodd


.headcls-7 
  fill: #fff
      
</style>


// WEBPACK FOOTER //
// src/components/pic/headerpic.vue